import { render } from "./AllMenuPositions.vue?vue&type=template&id=e7aff2dc&lang=pug"
import script from "./AllMenuPositions.vue?vue&type=script&setup=true&lang=js"
export * from "./AllMenuPositions.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__